import {
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  useQueryState,
} from 'nuqs'
import { useEffect, useState } from 'react'
import { fetchIntegrations } from 'routes/Integrations/helpers'
import { IntegrationCompactType } from 'routes/Integrations/helpers/types'

export function useIntegrations() {
  const [integrations, setIntegrations] = useState<IntegrationCompactType[]>([])
  const [totalAmount, setTotalAmount] = useState<number>(0)
  const [loadingIntegrations, setLoadingIntegrations] = useState<boolean>(true)

  const [search] = useQueryState('search', parseAsString.withDefault(''))
  const [category] = useQueryState('category', parseAsString.withDefault(''))
  const [filter] = useQueryState(
    'filter',
    parseAsArrayOf(parseAsString, ',').withDefault([]),
  )
  const [page] = useQueryState('page', parseAsInteger.withDefault(1))

  useEffect(() => {
    const controller = new AbortController()
    const { signal } = controller

    const fetchData = async () => {
      try {
        setLoadingIntegrations(true)
        const { integrations, totalAmount } = await fetchIntegrations({
          page,
          search,
          category,
          filter,
          signal,
        })
        if (signal?.aborted) return

        setIntegrations(integrations)
        setTotalAmount(totalAmount)
        setLoadingIntegrations(false)
      } catch (err) {
        console.warn(err)
      }
    }

    fetchData()

    return () => controller.abort()
  }, [page, search, category, filter.length])

  return {
    integrations,
    totalAmount,
    loadingIntegrations,
  }
}
